export interface GitlabPackage {
  version: string;
  created_at: string;
  name: string;
  conan_package_name?: string;
}
